import React, { useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

import api from '../../../../services/api';
import { FooterButton, ModalSubtitle } from '../EditWorkerModal/styles';

interface IProps {
  workerId: string;
  showModal: boolean;
  handleShowModal: (value: boolean) => void;
}

const RemoveFromSyndicateModal: React.FC<IProps> = ({
  workerId,
  showModal,
  handleShowModal,
}) => {
  const history = useHistory();

  const handleRemoveFromSyndicate = useCallback(async () => {
    await api.delete(`/workers/${workerId}`);
    history.push('/workers');
  }, [workerId, history]);

  return (
    <Modal
      show={showModal}
      onHide={() => handleShowModal(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title style={{ fontSize: 18, fontWeight: 700 }}>
            Remover do sindicato
          </Modal.Title>
          <ModalSubtitle>
            Esta ação removerá o vínculo do trabalhador com o sindicato.
          </ModalSubtitle>
        </div>
      </Modal.Header>

      <Modal.Body style={{ background: '#fafbfc', padding: 20 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            padding: '14px 16px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 12,
            fontSize: 13.5,
            color: '#7f1d1d',
            lineHeight: 1.5,
          }}
        >
          <FiAlertTriangle
            size={18}
            style={{ flexShrink: 0, marginTop: 2, color: '#b91c1c' }}
          />
          <span>
            Você deseja remover este trabalhador do sindicato? O cadastro do
            trabalhador será mantido, mas ele deixará de estar associado.
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <FooterButton
          type="button"
          $variant="secondary"
          onClick={() => handleShowModal(false)}
        >
          Cancelar
        </FooterButton>
        <FooterButton
          type="button"
          $variant="danger"
          onClick={handleRemoveFromSyndicate}
        >
          Remover
        </FooterButton>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveFromSyndicateModal;
